import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Logo, LogoWhite } from '../../components/Logo/Logo';
import { useTranslation } from '../../language';
import LanguageSelector from '../../language';
import { useTheme } from '@mui/material';

const LoginCardNew = ({ authform, content }) => {

  const { t } = useTranslation();
  const theme = useTheme();

    return (

      <Card elevation={0} variant="outlined"

        sx={{
          mx: 2,
          my: 6,
          pb: 2,
          bgcolor: 'transparent',
          border: 'none',
          borderRadius: "12px",
        }}>

        <CardContent sx={{display: 'grid', placeItems: 'center'}}>

          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
            {theme.palette.mode === 'dark' ? <LogoWhite /> : <Logo />}
          </Box>

          <Typography variant="h3" sx={{ mb: 1, textAlign: 'center' }}>
            {t('login_headline')}
          </Typography>

          <Typography variant="subtitle1" sx={{ mb: 1, textAlign: 'center', fontWeight: 400 }}>
            {t('login_subheadline')}
          </Typography>

          <Box sx={{ mb: 1 }}>
            <LanguageSelector />
          </Box>

          <Box sx={{ mt: 1, width: '100%' }}> {authform} </Box>

          {content}

        </CardContent>

      </Card>

    );
  };

  export default LoginCardNew;
